Dineplan.key = "CjxHhTrz";

$(window).on("load", function () {
  $("#status").fadeOut();
  $("#preloader").delay(1000).fadeOut("slow");
});

// As A jQuery Plugin -->
$(document).ready(function () {
  $(".popup-gallery").magnificPopup({
    delegate: "a",
    type: "image",
    tLoading: "Loading image #%curr%...",
    preloader: true,
    mainClass: "mfp-img-mobile",
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [4, 4], // Will preload 0 - before current, and 1 after the current image
    },
    image: {
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      titleSrc: '',
    },
  });
});

$(".picture-slideshow a").prepend('<div class="slideOverlay"></div>');
$(".rich-text .rich-text__heading--").prepend('<div class="titleLine"></div>');

$(document).ready(function () {
  if ($("#header").hasClass("menu_scroll_v1")) {
    $(".header-v1-h1 .logo a img").attr(
      "src",
      "https://cdn.shopify.com/s/files/1/0615/8663/7027/files/01_SZ-Logo-icon_4x-8_256x256_crop_center.png?v=1676301879"
    );
  }
  $(window).scroll(function (e) {
    if ($("#header").hasClass("menu_scroll_v1")) {
      $(".header-v1-h1 .logo a img").attr(
        "src",
        "https://cdn.shopify.com/s/files/1/0615/8663/7027/files/01_SZ-Logo-icon_4x-8_9006f957-db3c-4ab4-99d8-3a8632018098.png?v=1676325057"
      );
    } else {
      $(".header-v1-h1 .logo a img").attr(
        "src",
        "https://cdn.shopify.com/s/files/1/0615/8663/7027/files/logo-icon-dragonfly-white.png?v=1676317016"
      );
    }
  });
});